import { type ApolloLink } from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import { createGraphQLErrorHandler } from "./module";

export const createLogLink = (): ApolloLink => {
  const errorHandler = createGraphQLErrorHandler();
  return onError(errorHandler);
};
